(function(){
  'use strict';

  var wallRoot=document.querySelector('[data-mantra-wall]');
  var eventRoot=document.querySelector('.ezarc-event');
  if(!wallRoot&&!eventRoot)return;

  var storageKey='ezarc-builder-mantras-v1';
  var likeKey='ezarc-builder-mantra-likes-v1';
  var configRoot=eventRoot||wallRoot;
  var config={
    eyebrow:configRoot&&configRoot.getAttribute('data-mantra-modal-eyebrow')||'COMMUNITY CO-CREATION / NEXT SLEEVE EDITION',
    title:configRoot&&configRoot.getAttribute('data-mantra-modal-title')||'Pin Your Builder Mantra',
    intro:configRoot&&configRoot.getAttribute('data-mantra-modal-intro')||'Give the work a few words. We may print your voice on a future sleeve.',
    sloganLabel:configRoot&&configRoot.getAttribute('data-mantra-modal-slogan-label')||'Your slogan',
    storyLabel:configRoot&&configRoot.getAttribute('data-mantra-modal-story-label')||'What did the work make you feel?',
    colorLabel:configRoot&&configRoot.getAttribute('data-mantra-modal-color-label')||'Choose your sticky note color',
    avatarLabel:configRoot&&configRoot.getAttribute('data-mantra-modal-avatar-label')||'Choose your builder avatar',
    nameLabel:configRoot&&configRoot.getAttribute('data-mantra-modal-name-label')||'Name',
    shareNote:configRoot&&configRoot.getAttribute('data-mantra-modal-share-note')||'When you share your pinned mantra, use #WeAreAllBuilders #MySawBladeMyMood.',
    avatarLabels:{
      craftsman:eventRoot&&eventRoot.getAttribute('data-avatar-label-craftsman')||'Craftsman',
      yard_pro:eventRoot&&eventRoot.getAttribute('data-avatar-label-yard-pro')||'Yard Pro',
      home_dad:eventRoot&&eventRoot.getAttribute('data-avatar-label-home-dad')||'Home Dad',
      diy_builder:eventRoot&&eventRoot.getAttribute('data-avatar-label-diy-builder')||'DIY Builder',
      woodworker:eventRoot&&eventRoot.getAttribute('data-avatar-label-woodworker')||'Woodworker',
      weekend_pro:eventRoot&&eventRoot.getAttribute('data-avatar-label-weekend-pro')||'Weekend Pro'
    }
  };

  var colors={
    yellow:{label:'Builder Yellow',hex:'#f4c542',bg:'#fff9dc'},
    peach:{label:'Warm Peach',hex:'#f47c48',bg:'#fff1e9'},
    green:{label:'Workshop Green',hex:'#65a30d',bg:'#f2f8df'},
    sky:{label:'Toolbox Blue',hex:'#38a8d8',bg:'#eaf8fc'},
    purple:{label:'Dusty Purple',hex:'#7c6f93',bg:'#f2eff7'},
    wood:{label:'Raw Wood',hex:'#a66a3f',bg:'#f6eee7'}
  };
  var avatars={
    craftsman:'<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M9 21h30M13 21c1-7 5-11 11-11s10 4 11 11M9 21v5h30v-5M16 26v5m16-5v5"/><circle cx="18" cy="25" r="3"/><circle cx="30" cy="25" r="3"/><path d="M21 25h6"/></svg><span class="ezarc-mantra-modal__avatar-label">Craftsman</span>',
    yard_pro:'<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M9 35 20 24l7 7-11 11H9v-7ZM24 20l5-5 8 8-5 5M10 39h13"/><path d="M34 35c-7-1-10-5-9-11 7 0 11 4 9 11ZM26 38c3-6 6-10 11-14"/></svg><span class="ezarc-mantra-modal__avatar-label">Yard Pro</span>',
    home_dad:'<svg viewBox="0 0 48 48" aria-hidden="true"><path d="m7 23 17-14 17 14v16H7V23Z"/><path d="M18 39V27h12v12M32 14h5M37 9v5M34 11l5 5M34 16l5-5"/><circle cx="18" cy="20" r="3"/><circle cx="28" cy="20" r="2"/><path d="M21 23c2 3 5 3 7 0"/></svg><span class="ezarc-mantra-modal__avatar-label">Home Dad</span>',
    diy_builder:'<svg viewBox="0 0 48 48" aria-hidden="true"><path d="m10 34 20-20m-2-6 8 8-5 5-8-8 5-5ZM8 39h13"/><path d="M29 27h11v11H29zM29 32h5M34 27v5"/></svg><span class="ezarc-mantra-modal__avatar-label">DIY Builder</span>',
    woodworker:'<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M7 35h34M12 35V22h24v13M16 22l8-8 8 8M18 27h12M21 31h6"/><path d="m27 13 8 8M34 16l5 5M31 20l5 5"/></svg><span class="ezarc-mantra-modal__avatar-label">Woodworker</span>',
    weekend_pro:'<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M15 38c-2-3-3-8-2-13l2-12c0-2 3-2 3 0v8l2-14c0-2 3-2 3 0v13l2-15c0-2 3-2 3 0v15l2-11c0-2 3-2 3 0l-1 15c4-3 6 0 4 3l-5 9c-2 3-6 4-9 4H15Z"/><path d="M13 17h-3M35 17h3"/></svg><span class="ezarc-mantra-modal__avatar-label">Weekend Pro</span>'
  };
  var colorOrder=['yellow','peach','green','sky','purple','wood'];
  var avatarOrder=['craftsman','yard_pro','home_dad','diy_builder','woodworker','weekend_pro'];
  var avatarAliases={yard:'yard_pro',blade:'woodworker',builder:'diy_builder',workshop:'home_dad',grit:'weekend_pro'};
  var entries=[];
  var liked={};
  var lastFocus=null;
  var supabaseClient=null;
  var supabaseUrl='https://kfidvrxnyklqirpibwwy.supabase.co';
  var supabaseKey='sb_publishable_G1nRI7-UXUVvku0a6Hcojg_UDB_k6zs';

  function initSupabase(){
    if(window.supabase&&typeof window.supabase.createClient==='function'){
      supabaseClient=window.supabase.createClient(supabaseUrl,supabaseKey);
    }
  }

  function read(key,fallback){
    try{return JSON.parse(window.localStorage.getItem(key)||'')||fallback;}catch(error){return fallback;}
  }
  function save(key,value){
    try{window.localStorage.setItem(key,JSON.stringify(value));}catch(error){}
  }
  async function loadCloudEntries(){
    if(!supabaseClient||!wallRoot)return;
    try{
      var result=await supabaseClient.from('mantras').select('*').order('likes',{ascending:false});
      if(result.error)throw result.error;
      if(Array.isArray(result.data)){
        entries=result.data.map(normalizeCloudRow);
        save(storageKey,entries);
        renderWall();
      }
    }catch(error){
      if(window.console&&console.warn)console.warn('EZARC mantra cloud read unavailable; using local entries.',error.message||error);
    }
  }
  function subscribeToCloudEntries(){
    if(!supabaseClient||!wallRoot)return;
    supabaseClient.channel('ezarc-mantras-live').on('postgres_changes',{event:'*',schema:'public',table:'mantras'},function(payload){
      var incoming=payload.new&&normalizeCloudRow(payload.new);
      var id=incoming&&incoming.id;
      if(payload.eventType==='INSERT'&&incoming){entries=entries.filter(function(item){return item.id!==id;});entries.push(incoming);}
      if(payload.eventType==='UPDATE'&&incoming){entries=entries.map(function(item){return item.id===id?incoming:item;});}
      if(payload.eventType==='DELETE'){entries=entries.filter(function(item){return item.id!==payload.old.id;});}
      save(storageKey,entries);
      renderWall();
    }).subscribe();
  }
  function normalize(entry){
    var safe=entry||{};
    var avatarKey=avatarAliases[safe.avatar]||safe.avatar;
    return {
      id:String(safe.id||'mantra-'+Date.now()+'-'+Math.random().toString(36).slice(2,7)),
      slogan:String(safe.slogan||'').slice(0,50),
      story:String(safe.story||'').slice(0,80),
      name:String(safe.name||'Builder').slice(0,40),
      city:'',
      color:colors[safe.color]?safe.color:'yellow',
      avatar:avatars[avatarKey]?avatarKey:'diy_builder',
      customAvatar:safe.customAvatar||'',
      likes:Math.max(0,Number(safe.likes)||0),
      createdAt:Number(safe.createdAt)||Date.parse(safe.createdAt||'')||Date.now()
    };
  }
  function normalizeCloudRow(row){
    return normalize({
      id:row&&row.id,
      slogan:row&&row.slogan,
      story:row&&row.story,
      name:row&&(row.author||row.name),
      color:row&&row.color,
      avatar:row&&row.avatar,
      customAvatar:row&&row.custom_avatar,
      likes:row&&row.likes,
      createdAt:row&&(row.created_at||row.createdAt)
    });
  }
  function setSelected(selector,attribute,value,scope){
    (scope||document).querySelectorAll(selector).forEach(function(item){item.classList.toggle('is-selected',item.getAttribute(attribute)===value);});
  }
  function createColorOptions(){
    return colorOrder.map(function(key){var color=colors[key];return'<button type="button" class="ezarc-mantra-modal__color" data-modal-color="'+key+'" style="--modal-color:'+color.hex+'" aria-label="'+color.label+'"><span></span></button>';}).join('');
  }
  function createAvatarOptions(){
    return avatarOrder.map(function(key){
      var label=config.avatarLabels[key]||key;
      return'<button type="button" class="ezarc-mantra-modal__avatar" data-modal-avatar="'+key+'" aria-label="Choose '+label+' avatar">'+avatars[key].replace(/<span class="ezarc-mantra-modal__avatar-label">.*?<\/span>/,'<span class="ezarc-mantra-modal__avatar-label">'+label+'</span>')+'</button>';
    }).join('');
  }
  function getDestination(){
    var configured=eventRoot&&eventRoot.getAttribute('data-mantra-wall-link');
    if(configured)return configured;
    return (window.location.protocol==='file:'||/preview\.html$/i.test(window.location.pathname))?'preview-mantra-wall.html':window.location.href;
  }
  function createModal(){
    var existing=document.querySelector('[data-mantra-modal]');
    if(existing)return existing;
    var modal=document.createElement('div');
    modal.className='ezarc-mantra-modal ezarc-mantra-modal-overlay';
    modal.setAttribute('data-mantra-modal','');
    modal.setAttribute('aria-hidden','true');
    modal.setAttribute('role','dialog');
    modal.setAttribute('aria-modal','true');
    modal.setAttribute('aria-labelledby','ezarc-mantra-modal-title');
    modal.innerHTML='<div class="ezarc-mantra-modal__backdrop" data-mantra-close></div><div class="ezarc-mantra-portal" aria-hidden="true"><span></span><i></i></div><div class="ezarc-mantra-modal__panel ezarc-modal-content"><button type="button" class="ezarc-mantra-modal__close ezarc-modal-close" data-mantra-close aria-label="Close mantra form">&times;</button><div class="ezarc-mantra-modal__heading"><p class="modal-eyebrow">'+config.eyebrow+'</p><h2 class="modal-title" id="ezarc-mantra-modal-title">'+config.title+'</h2><span class="modal-subtitle">'+config.intro+'</span></div><form data-mantra-modal-form novalidate><label>'+config.sloganLabel+'<input name="slogan" type="text" maxlength="50" placeholder="&quot;AI Can&#39;t Replace This Craft.&quot;" required><small><b data-modal-slogan-count>0</b>/50</small></label><label>'+config.storyLabel+'<textarea name="story" maxlength="80" placeholder="The story behind this cut..." required></textarea><small><b data-modal-story-count>0</b>/80</small></label><fieldset><legend>'+config.colorLabel+'</legend><div class="ezarc-mantra-modal__colors">'+createColorOptions()+'</div></fieldset><fieldset><legend>'+config.avatarLabel+'</legend><div class="ezarc-mantra-modal__avatars">'+createAvatarOptions()+'</div><label class="ezarc-mantra-modal__upload">Upload Custom Photo<input type="file" accept="image/*" data-modal-upload><img data-modal-upload-preview alt="Custom avatar preview"></label></fieldset><div class="ezarc-mantra-modal__signature"><label>'+config.nameLabel+'<input name="name" type="text" maxlength="40" placeholder="Mike T." required></label></div><p class="ezarc-mantra-modal__share-note">'+config.shareNote+'</p><button class="ezarc-mantra-modal__submit modal-submit-btn" type="submit">🚀 Submit &amp; Pin to Wall</button><p class="ezarc-mantra-modal__status" data-modal-status aria-live="polite"></p></form></div>';
    document.body.appendChild(modal);
    return modal;
  }

  var modal=createModal();
  var modalForm=modal.querySelector('[data-mantra-modal-form]');
  var modalSlogan=modalForm.querySelector('[name="slogan"]');
  var modalStory=modalForm.querySelector('[name="story"]');
  var modalStatus=modal.querySelector('[data-modal-status]');
  var modalState={color:'yellow',avatar:'diy_builder',customAvatar:''};

  function resetModal(){
    modalForm.reset();
    modalState={color:'yellow',avatar:'diy_builder',customAvatar:''};
    setSelected('[data-modal-color]','data-modal-color','yellow',modal);
    setSelected('[data-modal-avatar]','data-modal-avatar','diy_builder',modal);
    var preview=modal.querySelector('[data-modal-upload-preview]');
    if(preview){preview.removeAttribute('src');preview.classList.remove('is-visible');}
    modalStatus.textContent='';
    modal.querySelector('[data-modal-slogan-count]').textContent='0';
    modal.querySelector('[data-modal-story-count]').textContent='0';
  }
  function openModal(){
    lastFocus=document.activeElement;
    resetModal();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('ezarc-mantra-modal-open');
    window.setTimeout(function(){modalSlogan.focus();},40);
  }
  function closeModal(){
    if(modal.classList.contains('is-flying'))return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('ezarc-mantra-modal-open');
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  function bindOpeners(scope){
    (scope||document).querySelectorAll('[data-mantra-open]').forEach(function(button){
      if(button.dataset.mantraBound)return;
      button.dataset.mantraBound='true';
      button.addEventListener('click',function(event){event.preventDefault();openModal();});
    });
  }
  window.EZARC_MANTRA_BIND=bindOpeners;
  bindOpeners(document);
  modal.querySelectorAll('[data-mantra-close]').forEach(function(button){button.addEventListener('click',closeModal);});
  modal.querySelectorAll('[data-modal-color]').forEach(function(button){button.addEventListener('click',function(){modalState.color=button.getAttribute('data-modal-color');modalState.customAvatar='';setSelected('[data-modal-color]','data-modal-color',modalState.color,modal);});});
  modal.querySelectorAll('[data-modal-avatar]').forEach(function(button){button.addEventListener('click',function(){modalState.avatar=button.getAttribute('data-modal-avatar');modalState.customAvatar='';setSelected('[data-modal-avatar]','data-modal-avatar',modalState.avatar,modal);var preview=modal.querySelector('[data-modal-upload-preview]');if(preview){preview.removeAttribute('src');preview.classList.remove('is-visible');}});});
  modalSlogan.addEventListener('input',function(){modal.querySelector('[data-modal-slogan-count]').textContent=modalSlogan.value.length;});
  modalStory.addEventListener('input',function(){modal.querySelector('[data-modal-story-count]').textContent=modalStory.value.length;});
  modal.querySelector('[data-modal-upload]').addEventListener('change',function(){
    var file=this.files&&this.files[0];
    if(!file||!/^image\//.test(file.type))return;
    var reader=new FileReader();
    reader.onload=function(){
      modalState.avatar='custom';
      modalState.customAvatar=reader.result;
      modal.querySelectorAll('[data-modal-avatar]').forEach(function(button){button.classList.remove('is-selected');});
      var preview=modal.querySelector('[data-modal-upload-preview]');
      preview.src=reader.result;
      preview.classList.add('is-visible');
    };
    reader.readAsDataURL(file);
  });

  async function appendEntry(){
    var entry=normalize({
      id:'mantra-'+Date.now()+'-'+Math.random().toString(36).slice(2,7),
      slogan:modalSlogan.value.trim(),
      story:modalStory.value.trim(),
      name:modalForm.querySelector('[name="name"]').value.trim(),
      color:modalState.color,
      avatar:modalState.avatar,
      customAvatar:modalState.customAvatar,
      likes:0,
      createdAt:Date.now()
    });
    if(supabaseClient){
      try{
        var result=await supabaseClient.from('mantras').insert({slogan:entry.slogan,story:entry.story,author:entry.name,city:'',color:entry.color,avatar:entry.avatar,likes:0}).select().single();
        if(result.error)throw result.error;
        if(result.data)entry=normalizeCloudRow(result.data);
      }catch(error){
        if(window.console&&console.warn)console.warn('EZARC mantra cloud write unavailable; keeping local entry.',error.message||error);
      }
    }
    entries.unshift(entry);
    save(storageKey,entries);
    return entry;
  }

  modalForm.addEventListener('submit',function(event){
    event.preventDefault();
    var nameInput=modalForm.querySelector('[name="name"]');
    if(!modalSlogan.value.trim()||!modalStory.value.trim()||!nameInput.value.trim()){
      modalStatus.textContent='Add your slogan, story, and name before pinning.';
      return;
    }
    modal.classList.add('is-flying');
    modal.querySelector('.ezarc-mantra-modal__submit').disabled=true;
    modalStatus.textContent='Sending your builder voice through the wall...';
    window.setTimeout(async function(){
      var entry=await appendEntry();
      modal.classList.remove('is-flying');
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      document.body.classList.remove('ezarc-mantra-modal-open');
      modal.querySelector('.ezarc-mantra-modal__submit').disabled=false;
      if(wallRoot){
        renderWall();
        var latest=wallRoot.querySelector('[data-mantra-id="'+entry.id+'"]');
        if(latest)window.setTimeout(function(){latest.scrollIntoView({behavior:'smooth',block:'center'});},40);
      }else{
        window.location.href=getDestination();
      }
    },750);
  });
  document.addEventListener('keydown',function(event){if(event.key==='Escape'&&modal.classList.contains('is-open'))closeModal();});

  function avatarNode(entry){
    if(entry.customAvatar){
      var image=document.createElement('img');
      image.src=entry.customAvatar;
      image.alt='Custom builder avatar';
      return image;
    }
    var holder=document.createElement('span');
    holder.innerHTML=avatars[entry.avatar]||avatars.builder;
    return holder.firstElementChild;
  }
  function sortedEntries(){
    return entries.slice().sort(function(a,b){return b.likes-a.likes||b.createdAt-a.createdAt;});
  }
  function renderWall(){
    if(!wallRoot)return;
    var grid=wallRoot.querySelector('[data-mantra-grid]');
    var empty=wallRoot.querySelector('[data-mantra-empty]');
    var count=wallRoot.querySelector('[data-mantra-count]');
    if(!grid)return;
    var sorted=sortedEntries();
    grid.innerHTML='';
    if(empty)empty.hidden=sorted.length>0;
    if(count)count.textContent=sorted.length;
    sorted.forEach(function(entry,index){
      var card=document.createElement('article');
      card.className='ezarc-sticky-note'+(index<3?' is-ranked':'');
      card.setAttribute('data-mantra-id',entry.id);
      card.style.setProperty('--note-color',colors[entry.color].hex);
      card.style.setProperty('--note-bg',colors[entry.color].bg);
      var hash=entry.id.split('').reduce(function(sum,char){return sum+char.charCodeAt(0);},0);
      card.style.setProperty('--note-tilt',((hash%7)-3)/2+'deg');
      if(index<3){
        var rank=document.createElement('span');
        rank.className='ezarc-sticky-note__rank ezarc-sticky-note__rank--'+index;
        rank.textContent=index===0?'🥇 Top 1':index===1?'🥈 Top 2':'🥉 Top 3';
        card.appendChild(rank);
      }
      var head=document.createElement('div');
      head.className='ezarc-sticky-note__head';
      var avatar=document.createElement('span');
      avatar.className='ezarc-sticky-note__avatar';
      avatar.appendChild(avatarNode(entry));
      var identity=document.createElement('div');
      identity.className='ezarc-sticky-note__identity';
      var name=document.createElement('strong');
      name.textContent=entry.name;
      identity.appendChild(name);
      head.append(avatar,identity);
      var slogan=document.createElement('p');
      slogan.className='ezarc-sticky-note__slogan';
      slogan.textContent='“'+entry.slogan+'”';
      var footer=document.createElement('div');
      footer.className='ezarc-sticky-note__footer';
      var story=document.createElement('p');
      story.className='ezarc-sticky-note__story';
      story.textContent=entry.story;
      var like=document.createElement('button');
      like.type='button';
      like.className='ezarc-sticky-note__like'+(liked[entry.id]?' is-liked':'');
      like.setAttribute('aria-pressed',liked[entry.id]?'true':'false');
      like.innerHTML='<span aria-hidden="true">'+(liked[entry.id]?'♥':'♡')+'</span><b>'+entry.likes+'</b>';
      like.addEventListener('click',function(){
        if(liked[entry.id])return;
        liked[entry.id]=true;
        entry.likes+=1;
        entries=entries.map(function(item){return item.id===entry.id?entry:item;});
        save(storageKey,entries);
        save(likeKey,liked);
        if(supabaseClient&&String(entry.id).indexOf('mantra-')!==0){
          supabaseClient.from('mantras').update({likes:entry.likes}).eq('id',entry.id).then(function(result){
            if(result.error&&window.console&&console.warn)console.warn('EZARC mantra cloud like update failed.',result.error.message||result.error);
          });
        }
        like.classList.add('is-liked','is-popping');
        like.setAttribute('aria-pressed','true');
        like.querySelector('span').textContent='♥';
        window.setTimeout(function(){renderWall();},450);
      });
      footer.append(story,like);
      card.append(head,slogan,footer);
      grid.appendChild(card);
    });
  }

  function setupCountdown(){
    if(!wallRoot)return;
    var output=wallRoot.querySelector('[data-mantra-countdown]');
    if(!output)return;
    var raw=wallRoot.getAttribute('data-mantra-draw-end-date');
    var deadline=Date.parse(raw||'');
    if(!deadline){output.textContent='30-day draw cycle';return;}
    function tick(){
      var remaining=Math.max(0,deadline-Date.now());
      var days=Math.floor(remaining/86400000);
      var hours=Math.floor(remaining%86400000/3600000);
      var minutes=Math.floor(remaining%3600000/60000);
      var seconds=Math.floor(remaining%60000/1000);
      output.textContent=remaining?'Cycle ends in '+days+'d '+hours+'h '+minutes+'m '+seconds+'s':'This draw cycle is complete. A new cycle starts soon.';
    }
    tick();
    window.setInterval(tick,1000);
  }

  initSupabase();
  entries=read(storageKey,[]).map(normalize);
  liked=read(likeKey,{});
  if(wallRoot){renderWall();bindOpeners(wallRoot);setupCountdown();loadCloudEntries();subscribeToCloudEntries();}
})();
